import { Component, OnInit } from '@angular/core';
import { InputSelectModel } from '../input-select/inputSelect.model';
import { InputModel } from '../input/input.model';
import { RequiredModel } from '../input/rules/implementations/required.model';
import { CreditCardCVVModel } from '../input/rules/implementations/creditCardCVV.model';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { ResponsibleService } from '../../services/responsible.service';
import { NotificationService } from '../../notification/swal/notification.service';
import { DuplicateMeepCardService } from '../../services/duplicate-meep-card.service';
import { Form } from '../../services/form';

@Component({
  selector: 'app-duplicate-pay',
  templateUrl: './duplicate-pay.component.html',
  styleUrls: ['./duplicate-pay.component.less']
})
export class DuplicatePayComponent extends Form implements OnInit {

  creditCards: Array<InputSelectModel> = new Array<InputSelectModel>();
  creditCard: any;
  showPayments: boolean;
  requisicaoGetAmountRealizada: boolean;
  amount = 0;
  securityCode: any;
  creditCardCVV = new InputModel(false, true, 'tel', 'CVV', [new RequiredModel()], new CreditCardCVVModel());

  routeParams: Params;

  constructor(private responsibleService: ResponsibleService, private notificationService: NotificationService,
    private route: ActivatedRoute, private duplicateMeepCardService: DuplicateMeepCardService,
    private router: Router) {
    super();
    this.route.params.subscribe((params: Params) => {
      this.routeParams = params;
    });
  }

  ngOnInit() {
    this.getAmount();
    this.getPaymentMethods();
  }

  private getPaymentMethods() {
    this.responsibleService.getCreditCards()
      .then((creditCards) => {
        creditCards.forEach((creditCard) => {
          this.creditCards.push({ title: `**** **** **** ${creditCard.finalNumero}`, value: creditCard });
        });
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  private getAmount() {
    this.duplicateMeepCardService.getAmountForDuplicate(this.routeParams['meepCardNumber'])
      .then((response: any) => {
        this.requisicaoGetAmountRealizada = true;
        this.amount = response.Valor;
        this.showPayments = !response.EhEmitidaPeloLocal && response.Valor !== 0;
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  registerCreditCard() {
    this.router.navigate(['/general/registrarCartao']);
  }

  buy() {
    this.notificationService.showQuestionNotification('Deseja realmente continuar?')
      .then(result => {
        if (result.value) {
          if ((this.showPayments && this.getFormStatus()) || (!this.showPayments)) {
            this.duplicateMeepCardService.generateDuplicate(this.routeParams['meepCardNumber'], this.creditCard, this.securityCode)
              .then((response: any) => {
                this.notificationService.showSuccessNotification('Sua solicitação foi salva. Em breve entraremos em contato.')
                  .then(() => {
                    this.router.navigate([`general/cartoesDependentes`]);
                  });
              })
              .catch((err) => {
                this.notificationService.showErrorNotification(err.message);
              });
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/duplicate-pay/duplicate-pay.component.ts